import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    widthClass?: string;
}

const FilterModal: React.FC<FilterModalProps> = ({
    isOpen,
    onClose,
    children,
    widthClass = ' w-full  md:w-[500px]',
}) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setShowModal(true), 10); 
        } else {
            setShowModal(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-50  flex justify-end bg-gray-800 bg-opacity-50 transition-opacity duration-300"
            onClick={onClose}
        >
            <div
                className={`
                    h-full relative bg-white  shadow-black py-6 px-2 md:p-4 rounded-md shadow-lg 
                    overflow-y-auto transform transition-transform duration-500 ease-in-out
                    ${showModal ? 'translate-x-0' : 'translate-x-full'}
                    ${widthClass}
                `}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="absolute  text-2xl right-4 text-gray-500 hover:text-gray-800"
                    onClick={onClose}
                >
                    &times;
                </button>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default FilterModal;
